import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import styled from "styled-components";
import homeLogo from "../../Assets/home-main.svg";

const StyledSection = styled.section`
  background-size: cover;
  color: var(--text-primary);
  position: relative;
  overflow: hidden;
  
  .heading {
    color: var(--text-primary);
    font-family: "Inter", sans-serif;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  
  .main-name {
    font-family: "Inter", sans-serif;
    color: var(--imp-text-color);
    font-weight: 700;
  }
  
  .subtext {
    color: var(--text-secondary);
    font-family: "Inter", sans-serif;
    font-size: 1.1rem;
    max-width: 600px;
    margin: 20px 0;
    line-height: 1.7;
  }

  .floating-animation {
    animation: float 6s ease-in-out infinite;
  }

  @keyframes float {
    0% {
      transform: translatey(0px);
    }
    50% {
      transform: translatey(-20px);
    }
    100% {
      transform: translatey(0px);
    }
  }
  
  .wave {
    animation-duration: 1.8s;
    animation-iteration-count: infinite;
    transform-origin: 70% 70%;
    display: inline-block;
  }
  
  .home-content {
    padding: 3rem 0 0 !important;
    color: var(--text-primary);
    text-align: left;
    position: relative;
    z-index: 0;
  }
  
  .home-header {
    padding-top: 2rem;
    text-align: left;
    position: relative;
    z-index: 0;
  }
  
  .heading-name {
    font-size: 2.5rem !important;
    margin-bottom: 1.5rem;
  }
  
  .Typewriter__wrapper {
    font-size: 2.2em !important;
    color: var(--imp-text-color) !important;
    font-weight: 600 !important;
  }
  
  .Typewriter__cursor {
    font-size: 2.4em !important;
    color: var(--text-secondary) !important;
  }
  
  .home-img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    padding-bottom: 0;
  }
  
  @media (max-width: 767px) {
    .heading-name {
      font-size: 1.9rem !important;
      padding-left: 0 !important;
    }
    
    .Typewriter__wrapper {
      font-size: 1.4em !important;
    }
    
    .Typewriter__cursor {
      font-size: 1.4em !important;
    }
    
    .home-content {
      padding: 2rem 0 0 !important;
    }
  }
`;

function Home() {
  return (
    <StyledSection>
      <Container fluid className="home-section home-section-shorter" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="align-items-center">
            <Col md={7} className="home-header">
              <h1 className="heading">
                Bonjour{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                Je suis <strong className="main-name">Mehdi Chafai</strong>
              </h1>
              
              <p className="subtext">
                Développeur passionné de création d'applications web innovantes et intuitives.
              </p>

              <div style={{ padding: "15px 0 0", textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} className="home-img-container">
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid floating-animation"
                style={{ maxHeight: "320px", width: "100%" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </StyledSection>
  );
}

export default Home;